import {Component, OnInit} from '@angular/core';
import {FloorManagerReportService} from '../../../core/service/floor-manager-report.service';
import {FloorManagerMonthlyOverviewReport} from '../../../model/report/floormanager/floor-manager-monthly-overview-report';
import * as moment from 'moment';

@Component({
	selector: 'app-report-floor-manager',
	templateUrl: './report-floor-manager.component.html',
	styleUrls: ['./report-floor-manager.component.scss']
})
export class ReportFloorManagerComponent implements OnInit {
	report: FloorManagerMonthlyOverviewReport;
	months: string[] = [];
	years: string[] = [];
	selectedMonth = moment().format('MMMM');
	selectedYear = moment().format('YYYY');

	constructor(
		private floorManagerReportService: FloorManagerReportService
	) {}

	ngOnInit(): void {
		this.loadReport(this.getSelectedMoment());
	}

	updateReport(): void {
		this.loadReport(this.getSelectedMoment());
	}

	getSelectedMoment(): moment.Moment {
		return moment()
			.set('year', Number(this.selectedYear))
			.set('month', moment().month(this.selectedMonth).month())
			.startOf('month');
	}

	private loadReport(date: moment.Moment): void {
		this.floorManagerReportService.getMonthlyOverview(date.valueOf()).subscribe(result => {
			this.report = result;
			this.updateDateSelectors();
		});
	}

	private updateDateSelectors(): void {
		const firstAvailableDate = this.report && this.report.firstAvailableDate ?
			moment(this.report.firstAvailableDate).startOf('month') :
			moment().startOf('month');
		const now = moment().startOf('month');

		this.years = [];
		this.months = [];

		let yearCursor = firstAvailableDate.clone().startOf('year');
		while (yearCursor.isSameOrBefore(now, 'year')) {
			this.years.push(yearCursor.format('YYYY'));
			yearCursor = yearCursor.add(1, 'year');
		}

		let monthCursor = moment().set('year', Number(this.selectedYear)).startOf('year');
		for (let i = 0; i < 12; i++) {
			if (monthCursor.isSameOrAfter(firstAvailableDate) && monthCursor.isSameOrBefore(now, 'month')) {
				this.months.push(monthCursor.format('MMMM'));
			}
			monthCursor = monthCursor.add(1, 'month');
		}

		if (this.years.indexOf(this.selectedYear) === -1) {
			this.selectedYear = now.format('YYYY');
		}
		if (this.months.indexOf(this.selectedMonth) === -1) {
			this.selectedMonth = this.months[this.months.length - 1];
		}
	}
}
